export default __webpack_public_path__ + "static/media/cloud_dreams.74ef98c6.png";